import React, { Fragment } from "react";
import CardBase from "../../ui/cards/CardBase";
import Icon from "../../ui/Icon";

import PlayerAbilityCardItem from "./PlayerAbilityCardItem";
import Divider from "../../ui/Divider";
// Stylesheet file.
import '../../../assets/sass/global/cards/player-ability-card.scss';
import { Row, Col } from "react-bootstrap";
import classes from "classnames";
import ShadowScrollbars from "../custom_scrollbars/ShadowScrollbars";

class PlayerAbilityCard extends CardBase {
    /**
     * Renders the header of the card component.
     * @override
     * @returns {React.ReactNode} The card header component.
     */
    renderHeader = () => {
        const { title, icon } = this.props;

        return (
            <Fragment>
                <Icon className="player-ability-card--icon black" svg={icon} />
                <div className="player-ability-card--title">{title}</div>
            </Fragment>
        );
    };


    /**
     * Renders the body of the card component.
     * @override
     * @returns {React.ReactNode} The card body component.
     */
    renderBody = () => {
        const { items, withHorizontalDivider, onAttachmentClick, columns, scrollable } = this.props;

        const itemsPerColumn = items.length / columns;        
        const content = (
            <Row className="gutters-6">
                {
                    [...Array(columns)].map((v, columnNum) => {
                        const indexOfFirstItemInCol = itemsPerColumn * columnNum;
                        const indexOfLastItemInCol = indexOfFirstItemInCol + itemsPerColumn;

                        return (
                            <Col md={12 / columns}>

                                <div className="items">

                                    {items.slice(indexOfFirstItemInCol, indexOfLastItemInCol).map((item, index) =>
                                        <Fragment>
                                            <PlayerAbilityCard.Item
                                                key={index}
                                                title={item.title}
                                                description={item.description}
                                                value={item.value}
                                                attachments={item.attachments}
                                                onAttachmentClick={onAttachmentClick}
                                            />
                                            <Divider show={withHorizontalDivider && index !== items.length - 1} />
                                        </Fragment>
                                    )}

                                </div>

                            </Col>
                        )
                    })
                }
            </Row>
        );

        return scrollable ? (
            <ShadowScrollbars>
                {content}
            </ShadowScrollbars>
        ) : content;
    };

    /**
     * Returns the classes of the card component.
     * @override
     * @returns {string} The card classes.
     */
    cardClasses = () => classes('player-ability-card', this.props.className);

    static defaultProps = {
        columns: 1
    }
}

PlayerAbilityCard.Item = PlayerAbilityCardItem;

export default PlayerAbilityCard;
